import UserWrapper from "../../../../layout/userwrapper/UserWrapper";
import { Box, Paper, Stack } from "@mui/material";
import React, { useState } from "react";
import styles from "../../../../styles/pages/user/content-buyer-notification.module.scss";
import ContentbuyerNotificationFilter from "../../../../components/ContentbuyerNotificationFilter/ContentbuyerNotificationFilter";
import ContentbuyerNotificationTab from "../../../../components/ContentbuyerNotificationTab/ContentbuyerNotificationTab";
import { parseCookies } from "nookies";
import useInfinitePost from "../../../../hooks/api/useInfiniteFetch";
import axiosInstance from "../../../../api/axiosInstance";

const Notification = () => {
    const [date, setDate] = useState({ startDate: "", endDate: "", type: "" });
    const [search, setSearch] = useState("");
    const getDataFromChild = (data) => {
        if (data.startDate && data.endDate) {
            setDate(data);
        } else {
            setSearch(data);
        }
    };

    const cookies = parseCookies();
    const userDetails = JSON?.parse(cookies?.userdetails || "{}");

    const [notificationTypeList, setNotificationTypeList] = useState([]);
    const [filterArchive, setFilterArchive] = useState(0);

    const {
        data: notificationsList,
        isSuccess,
        isError,
        isLoading,
        refetch: refetchNotificationsList,
        hasNextPage,
        isFetching,
        fetchNextPage,
    } = useInfinitePost(
        [
            "notification",
            date?.startDate,
            date?.endDate,
            search,
            notificationTypeList,
            filterArchive,
        ],
        `notifications`,
        {
            search: search,
            notification_type_id: notificationTypeList.join(", "),
            archive: filterArchive,
            from: date?.startDate,
            to: date?.endDate,
        }
    );

    const updateNotification = async (data) => {
        await axiosInstance
            .post("notification-status-update", data)
            .then((res) => {
                refetchNotificationsList();
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const updateNotificationSeen = (notification) => {
        updateNotification({
            notification_id: notification?.id,
            seen: notification?.seen ? 0 : 1,
        });
    };
    const updateNotificationArchive = (notification) => {
        updateNotification({
            notification_id: notification?.id,
            archive: 1,
        });
    };

    const updateNotificationReadAll = () => {
        updateNotification({ read_all: "yes" });
    };
    const updateNotificationArchiveAll = () => {
        updateNotification({ archive_all: "yes" });
    };
    const updateNotificationDelete = (notification) => {
        updateNotification({
            notification_id: notification?.id,
            delete: "yes",
        });
    };
    const updateNotificationDeleteAll = () => {
        updateNotification({ delete_all: "yes" });
    };

    return (
        <UserWrapper headerPurchaseBtn={true} footerChatBtn={true}>
            <Paper
                elevation={0}
                className={`pageInnerWrapper ${styles.pageNotification}`}
            >
                <Stack
                    direction="row"
                    flexWrap="wrap"
                    className={styles.notificationWrapper}
                >
                    <ContentbuyerNotificationFilter
                        getDataFromChild={getDataFromChild}
                        filterType={"notification"}
                    />
                    <Box
                        className={`${styles.tabsNotification} ${styles.tabpanelCenter}`}
                    >
                        <Box className={styles.tabsInner}>
                            <ContentbuyerNotificationTab
                                notifiactionsListIsLoading={isLoading}
                                notifiactionsList={notificationsList?.pages}
                                updateNotificationSeen={updateNotificationSeen}
                                updateNotificationArchive={
                                    updateNotificationArchive
                                }
                                updateNotificationReadAll={
                                    updateNotificationReadAll
                                }
                                updateNotificationArchiveAll={
                                    updateNotificationArchiveAll
                                }
                                updateNotificationDelete={
                                    updateNotificationDelete
                                }
                                updateNotificationDeleteAll={
                                    updateNotificationDeleteAll
                                }
                                setFilterArchive={setFilterArchive}
                                hasNextPage={hasNextPage}
                                fetchNextPage={fetchNextPage}
                            />
                        </Box>
                    </Box>
                </Stack>
            </Paper>
        </UserWrapper>
    );
};

export default Notification;
